import React from "react";

const ActivityLogReferral = () => {
  return <div>ActivityLogReferral</div>;
};

export default ActivityLogReferral;